export default import.meta.ROLLUP_FILE_URL_WPGYjwIlzWVNM1bYhOc83w;